<template>
  <CModal
    size="lg"
    alignment="center"
    :visible="show"
    @close="$emit('closeImg')"
  >
    <CModalBody class="d-flex justify-content-center align-items-center">
      <img
        @click="$emit('closeImg')"
        class="close-icon"
        src="@/assets/icons/close.svg"
      />
      <CImage class="mb-4" rounded thumbnail :src="image" />
    </CModalBody>
  </CModal>
</template>
<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    image: {
      type: String,
      default: '',
    },
  },
  emits: ['closeImg'],
  setup() {},
}
</script>
<style lang="scss" scoped>
.close-icon {
  width: 30px;
  position: absolute;
  right: 10px;
  margin: 10px;
  top: 5px;
  cursor: pointer;
}
</style>
